export default __webpack_public_path__ + "static/media/indonesia2018D.15533e6b.jpg";